/** Must stay in sync with BrowserRouter basename in App.tsx */
export function getRouterBasename(): string {
  if (typeof window === 'undefined') return '/';
  return window.location.pathname.endsWith('index_app.html') ? '/index_app.html' : '/';
}

export function hrefDebugMessageExchange(messageExchangeId: string): string {
  const bn = getRouterBasename();
  return bn === '/' ? `/debug/${messageExchangeId}` : `${bn}/debug/${messageExchangeId}`;
}
